import { Scopes } from '@bingads-webui-campaign-react/goal-selector';

export const STEP_PATHS = {
  CAMPAIGN_SETTINGS: 'CAMPAIGN_SETTINGS',
  ASSET_GROUP: 'ASSET_GROUP',
};

export const ScenarioName = {
  PerformanceMaxCampaignCreation: 'PerformanceMaxCampaignCreation',
  PerformanceMaxAssetGroupCreation: 'PerformanceMaxAssetGroupCreation',
  PerformanceMaxCampaignSettings: 'PerformanceMaxCampaignSettings',
  PerformanceMaxAssetGroupSettings: 'PerformanceMaxAssetGroupSettings',
};

export const initialCampaignData = {
  Name: '',
  Status: 'Active',
  TimeZone: 'PacificTimeUSCanadaTijuana',
  Budget: {
    Amount: 25,
    Type: 'DailyStandard',
  },
  Languages: ['English'],
  BiddingScheme: {
    Type: undefined,
    TargetCpa: undefined,
    TargetRoas: undefined,
  },
  CampaignType: 'PerformanceMax',
  FinalUrlSuffix: '',
  TrackingUrlTemplate: '',
  UrlCustomParameters: [],
  locationTargets: {
    bidMode: false,
    currentLevelSettings: {
      initLocations: [],
      peopleInLocation: true,
      peopleSearchingForLocation: true,
      targetOption: 'everywhere',
    },
    parentLevelSettings: {},
    useParentLevel: false,
  },
  adSchedules: {
    adScheduleUseSearcherTimeZone: undefined,
    dayTimeRanges: [],
    timeZone: undefined,
  },
  finalUrlExpansions: [],
  conversionGoals: {
    originalConversionGoals: [],
    goalSelection: [],
    goalScopeSelection: Scopes.ACCOUNT,
  },
  ProviderId: '',
  IsFeedFiltered: false,
  SalesCountry: undefined,
  FeedLabel: undefined,
  LocalInventoryAdsEnabled: false,
  finalUrlExpansionOptOut: false,
  costPerSaleOptOut: false,
};

export const initialBrandExclusionsData = {
  addedBrandListIds: [],
  deletedBrandListIds: [],
  savedAddedBrandListIds: [],
  savedDeletedBrandListIds: [],
};

export const minuteMap = {
  0: 'ZERO',
  15: 'FIFTEEN',
  30: 'THIRTY',
  45: 'FORTY_FIVE',
};

export const initialAssetGroupData = {
  Status: 'Active',
  // TODO: use for testing bulkupsert. Remove after integration is complete.
  // Name: 'ag01',
  // Headlines: {
  //   Headline0: 'a1',
  //   Headline1: 'a2',
  //   Headline2: 'a3',
  // },
  // LongHeadlines: {
  //   LongHeadline0: 'a4',
  // },
  // Descriptions: {
  //   Description0: 'a5',
  //   Description1: 'a6',
  // },
  // Images: [{
  //   '@odata.type': '#Model.ImageAsset',
  //   Id: 13812614829529,
  //   IdString: '13812614829529',
  //   SubType: 'LandscapeImageMedia191X100',
  //   CropX: 0,
  //   CropY: 0,
  //   CropWidth: 2048,
  //   CropHeight: 1072,
  // }, {
  //   '@odata.type': '#Model.ImageAsset',
  //   Id: 13812614829531,
  //   IdString: '13812614829531',
  //   SubType: 'SquareImageMedia',
  //   CropX: 0,
  //   CropY: 0,
  //   CropWidth: 1014,
  //   CropHeight: 1014,
  // }, {
  //   '@odata.type': '#Model.ImageAsset',
  //   Id: 13812614829532,
  //   IdString: '13812614829532',
  //   SubType: 'SquareLogoMedia',
  //   CropX: 0,
  //   CropY: 0,
  //   CropWidth: 1072,
  //   CropHeight: 1072,
  // }],
  // BusinessName: 'bn',
  // CallToAction: 'Unknown',
  // FinalUrls: [
  //   'https://fr.com',
  // ],
};

export const campaignLanguageStrings = {
  Albanian: _TL_('Albanian'),
  Arabic: _TL_('Arabic'),
  Bosnian: _TL_('Bosnian'),
  Bulgarian: _TL_('Bulgarian'),
  Croatian: _TL_('Croatian'),
  Czech: _TL_('Czech'),
  Danish: _TL_('Danish'),
  Dutch: _TL_('Dutch'),
  English: _TL_('English'),
  Estonian: _TL_('Estonian'),
  Finnish: _TL_('Finnish'),
  French: _TL_('French'),
  German: _TL_('German'),
  Greek: _TL_('Greek'),
  Hungarian: _TL_('Hungarian'),
  Icelandic: _TL_('Icelandic'),
  Italian: _TL_('Italian'),
  Japanese: _TL_('Japanese'),
  Latvian: _TL_('Latvian'),
  Lithuanian: _TL_('Lithuanian'),
  Macedonian: _TL_('Macedonian'),
  Maltese: _TL_('Maltese'),
  Norwegian: _TL_('Norwegian'),
  Polish: _TL_('Polish'),
  Portuguese: _TL_('Portuguese'),
  Romanian: _TL_('Romanian'),
  Russian: _TL_('Russian'),
  Serbian: _TL_('Serbian'),
  SimplifiedChinese: _TL_('Simplified Chinese'),
  Slovak: _TL_('Slovak'),
  Slovenian: _TL_('Slovenian'),
  Spanish: _TL_('Spanish'),
  Swedish: _TL_('Swedish'),
  TraditionalChinese: _TL_('Traditional Chinese'),
  Turkish: _TL_('Turkish'),
  Hebrew: _TL_('Hebrew'),
  Hindi: _TL_('Hindi'),
  Malay: _TL_('Malay'),
  Thai: _TL_('Thai'),
  Indonesian: _TL_('Indonesian'),
  Tagalog: _TL_('Tagalog'),
  Vietnamese: _TL_('Vietnamese'),
};

export const CampaignNegativeReferenceId = -111;
export const AssetGroupNegativeReferenceId = -21;

export const SupportedExtensionPreviewTypes = {
  Sitelink: 'Sitelink2AdExtension',
  Callout: 'CalloutAdExtension',
  StructuredSnippet: 'StructuredSnippetAdExtension',
  Promotion: 'PromotionAdExtension',
  Price: 'PriceAdExtension',
};
